"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.installability = exports.reviewStats = exports.reviews = exports.connectionType = exports.requestState = exports.storefrontFilters = exports.dataSync = exports.pricingPlan = exports.pricingPlanType = exports.hubspotFeature = exports.categoryFeature = exports.dataSyncDirection = exports.storefrontCollection = exports.superCategory = exports.category = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var Data = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/dataSyncs/Data"));

var Sync = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/dataSyncs/Sync"));

var SuperCategory = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/groupTags/SuperCategory"));

var HubSpotFeature = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/groupTags/HubSpotFeature"));

var _categoryFeatures = require("ecosystem-marketplace-core/constants/groupTags/categoryFeatures");

var _category = _interopRequireDefault(require("ecosystem-marketplace-core/constants/propTypes/category"));

var _createObjectValuesPropType = _interopRequireDefault(require("ecosystem-marketplace-core/constants/propTypes/createObjectValuesPropType"));

var _planType = _interopRequireDefault(require("ecosystem-marketplace-core/constants/propTypes/planType"));

var _AppInstallability = _interopRequireDefault(require("ecosystem-marketplace-core/records/AppInstallability"));

var _StorefrontFilters = _interopRequireDefault(require("../records/StorefrontFilters"));

var StorefrontCollection = _interopRequireWildcard(require("./StorefrontCollection"));

var RequestState = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/RequestState"));

var ConnectionType = _interopRequireWildcard(require("./ConnectionType"));

var _Review = _interopRequireDefault(require("ecosystem-marketplace-core/records/Review"));

var _ReviewStats = _interopRequireDefault(require("ecosystem-marketplace-core/records/ReviewStats"));

var category = _category.default;
exports.category = category;
var superCategory = (0, _createObjectValuesPropType.default)(SuperCategory);
exports.superCategory = superCategory;
var storefrontCollection = (0, _createObjectValuesPropType.default)(StorefrontCollection);
exports.storefrontCollection = storefrontCollection;
var dataSyncDirection = (0, _createObjectValuesPropType.default)(Sync);
exports.dataSyncDirection = dataSyncDirection;

var categoryFeature = _propTypes.default.oneOf(Object.values(_categoryFeatures.BY_CATEGORY).reduce(function (acc, current) {
  return acc.concat(Object.values(current));
}, []));

exports.categoryFeature = categoryFeature;
var hubspotFeature = (0, _createObjectValuesPropType.default)(HubSpotFeature);
exports.hubspotFeature = hubspotFeature;
var pricingPlanType = _planType.default;
exports.pricingPlanType = pricingPlanType;

var pricingPlan = _reactImmutableProptypes.default.recordOf({
  cents: _propTypes.default.number.isRequired,
  commitmentCents: _propTypes.default.number,
  extraCharges: _propTypes.default.string,
  features: _propTypes.default.string,
  freeTrialDays: _propTypes.default.number,
  name: _propTypes.default.string.isRequired,
  planType: pricingPlanType.isRequired,
  tagline: _propTypes.default.string
});

exports.pricingPlan = pricingPlan;

var dataSync = _reactImmutableProptypes.default.recordOf({
  data: _propTypes.default.oneOf(Object.values(Data)).isRequired,
  description: _propTypes.default.string,
  sync: dataSyncDirection.isRequired,
  target: _propTypes.default.string.isRequired
});

exports.dataSync = dataSync;

var storefrontFilters = _propTypes.default.instanceOf(_StorefrontFilters.default);

exports.storefrontFilters = storefrontFilters;
var requestState = (0, _createObjectValuesPropType.default)(RequestState);
exports.requestState = requestState;
var connectionType = (0, _createObjectValuesPropType.default)(ConnectionType);
exports.connectionType = connectionType;

var reviews = _reactImmutableProptypes.default.listOf(_propTypes.default.instanceOf(_Review.default));

exports.reviews = reviews;

var reviewStats = _propTypes.default.instanceOf(_ReviewStats.default);

exports.reviewStats = reviewStats;

var installability = _propTypes.default.instanceOf(_AppInstallability.default);

exports.installability = installability;


//////////////////
// WEBPACK FOOTER
// ./js/constants/PropTypes.js
// module id = 34
// module chunks = 209 210 211 212